import { СssSetNaming, DEFAULT_PALETTE, DEFAULT_SPACING } from 'styles';

export default function isValidCssPair<T extends string | number>({
    naming,
    key,
    value,
}: {
    naming: СssSetNaming;
    key: string;
    value: T;
}): Error | undefined {
    let defaultValues = {};

    let ref: 'string' | 'number' = 'string';

    switch (naming) {
        case СssSetNaming.PALETTE: {
            ref = 'string';
            defaultValues = DEFAULT_PALETTE;
            break;
        }

        case СssSetNaming.SPACING: {
            ref = 'number';
            defaultValues = DEFAULT_SPACING;
            break;
        }

        default: {
            break;
        }
    }

    if (!(key in defaultValues)) {
        return new Error(`Not supported ${naming} key: ${key}`);
    }

    if (typeof value !== ref) {
        return new Error(
            `Not supported value of ${naming} key. Key: ${key}. Value: ${value}`
        );
    }
}
